import { useContext } from 'react';

import { PlayerContext } from './player_context';

export const useBasePlayerContext = () => {
  const contextValue = useContext(PlayerContext);
  if (!contextValue) {
    throw new Error(
      'usePlayerContext hook must be used within a PlayerStoreContextProvider component.',
    );
  }

  return contextValue;
};
